import React from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { usePageTitle } from '../../hooks/usePageTitle';

const UserManagement: React.FC = () => {
  usePageTitle('User Management | From the Pitchside');

  const { user } = useAuthContext();

  return (
    <div className="text-darkblue">
        <h2>User Management</h2>
    </div>
  );
};

export default UserManagement;
